import { configManagerCloudServicesApi as api } from '../configManagerCloudServicesApi';
import {
  GetCurrentBillingProfileApiResponse,
  GetCurrentBillingProfileApiArg,
  UpdateCurrentBillingProfileApiResponse,
  UpdateCurrentBillingProfileApiArg,
} from './types';

const injectedRtkApi = api.injectEndpoints({
  endpoints: build => ({
    getCurrentBillingProfile: build.query<GetCurrentBillingProfileApiResponse, GetCurrentBillingProfileApiArg>({
      query: () => ({ url: `/config-manager-cloud-services/api/v1/billing-profile/current` }),
      providesTags: ['BILLING_PROFILE'],
    }),
    updateCurrentBillingProfile: build.mutation<
      UpdateCurrentBillingProfileApiResponse,
      UpdateCurrentBillingProfileApiArg
    >({
      query: queryArg => ({
        url: `/config-manager-cloud-services/api/v1/billing-profile/current/update`,
        method: 'PUT',
        body: queryArg.billingUpdates,
      }),
      invalidatesTags: ['BILLING_PROFILE'],
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as billingApi };

export const { useGetCurrentBillingProfileQuery, useUpdateCurrentBillingProfileMutation } = injectedRtkApi;
